/* eslint-disable react/jsx-pascal-case */
import { Typography } from "@progress/kendo-react-common";
import * as React from "react";
import { useContext } from "react";
import { Label } from "@progress/kendo-react-labels";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { Frequency } from "../../../../ViewModel/Frequency";
import { EditProjectContext } from "../../../EditProjectContext";
import ShipDaysMultiSelect from "./ShipDaysMultiSelect";
import { CrossingCountryGrid } from "./CrossingCountries/CrossingCountryGrid";
import Row from "../../../../../Layout/PageGrid/Row";
import Col from "../../../../../Layout/PageGrid/Col";
import { FtlRouteFrequency } from "./FtlRouteFrequency";
import { inboundAndReturnFrequencies } from "./inboundAndReturnFrequencies";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

type Props = {
  route: FtlRouteViewModel;
};

export const RouteDetails = ({ route, isReadOnly }: Props & ReadOnlyProps) => {
  const { project, setProject } = useContext(EditProjectContext);
  const isProjectOrUserReadOnly = isProjectReadOnly(project) || isReadOnly;

  const setInboundFrequency = (frequency: Frequency) => {
    function updateFtlRoute(ftlRoute: FtlRouteViewModel) {
      if (ftlRoute.RouteId === route.RouteId && ftlRoute.RouteId != null && route.RouteId != null) {
        return {
          ...ftlRoute,
          InboundFrequency: frequency,
        };
      }
      return ftlRoute;
    }

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    });
  };

  const setReturnFrequency = (frequency: Frequency) => {
    function updateFtlRoute(ftlRoute: FtlRouteViewModel) {
      if (ftlRoute.RouteId === route.RouteId && ftlRoute.RouteId != null && route.RouteId != null) {
        return {
          ...ftlRoute,
          ReturnFrequency: frequency,
        };
      }
      return ftlRoute;
    }

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    });
  };

  const setShipDaysInbound = (shipDays: Array<string>) => {
    function updateFtlRoute(ftlRoute: FtlRouteViewModel) {
      if (ftlRoute.RouteId === route.RouteId && ftlRoute.RouteId != null && route.RouteId != null) {
        return {
          ...ftlRoute,
          ShipDaysInbound: shipDays,
        };
      }
      return ftlRoute;
    }

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    });
  };

  const setShipDaysReturn = (shipDays: Array<string>) => {
    function updateFtlRoute(ftlRoute: FtlRouteViewModel) {
      if (ftlRoute.RouteId === route.RouteId && ftlRoute.RouteId != null && route.RouteId != null) {
        return {
          ...ftlRoute,
          ShipDaysReturn: shipDays,
        };
      }
      return ftlRoute;
    }

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    });
  };

  return (
    <>
      <Typography.h4>Route Details</Typography.h4>
      <Row gap="25px" marginBottom="2rem" alignItems="start">
        <Col width="40%">
          <CrossingCountryGrid
            routeId={route.RouteId}
            crossingCountries={route.CrossingCountries ?? []}
            isReadOnly={isReadOnly}
          />
        </Col>
        <Col width="16.6%">
          <FtlRouteFrequency
            header="Inbound Frequency"
            frequency={route.InboundFrequency}
            inboundAndReturnFrequencies={inboundAndReturnFrequencies}
            handleChange={setInboundFrequency}
            disabled={isProjectOrUserReadOnly}
          />
        </Col>
        <Col width="16.6%">
          <FtlRouteFrequency
            header="Return Frequency"
            frequency={route.ReturnFrequency}
            inboundAndReturnFrequencies={inboundAndReturnFrequencies}
            handleChange={setReturnFrequency}
            disabled={isProjectOrUserReadOnly}
          />
        </Col>
        <Col width="15%">
          <Label>Ship Days Inbound</Label>
          <ShipDaysMultiSelect
            disabled={isProjectOrUserReadOnly}
            setShipDays={setShipDaysInbound}
            shipDays={route.ShipDaysInbound ?? []}
          />
        </Col>
        <Col width="15%">
          <Label>Ship Days Return</Label>
          <ShipDaysMultiSelect
            disabled={isProjectOrUserReadOnly}
            setShipDays={setShipDaysReturn}
            shipDays={route.ShipDaysReturn ?? []}
          />
        </Col>
      </Row>
    </>
  );
};
